import React from "react";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";

const OverallRating = () => {
  return (
    <div>
      <div className="rating-title-section">
        <div className="rating-summary">
          {/* <div className="rating-stars">★★★★☆</div> */}
          <div className="rating-stars">
            <StarRoundedIcon
              className="filled-star"
              sx={{ color: "#ffc107" }}
            />
            <StarRoundedIcon
              className="filled-star"
              sx={{ color: "#ffc107" }}
            />
            <StarRoundedIcon
              className="filled-star"
              sx={{ color: "#ffc107" }}
            />
            <StarRoundedIcon
              className="filled-star"
              sx={{ color: "#ffc107" }}
            />
            <StarOutlineRoundedIcon
              className="empty-star"
              sx={{ color: "#ababab" }}
            />
          </div>
          <div className="rating-score">4.0 out of 5</div>
          <button className="rating-download-btn">
            Download Full Report (PDF)
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverallRating;
